"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubStatus = void 0;
var HubStatus;
(function (HubStatus) {
    HubStatus["Active"] = "ACTIVE";
    HubStatus["Inactive"] = "INACTIVE";
    HubStatus["Maintenance"] = "MAINTENANCE";
    HubStatus["Pending"] = "PENDING";
})(HubStatus = exports.HubStatus || (exports.HubStatus = {}));
